import React, { memo } from 'react'
import styled from 'react-emotion'
import BlockText from './BlockText'
import BlockImage from './BlockImage'
import BlockEmbed from './BlockEmbed'
import { z } from '../../../style'
import BlockViewOptions from './BlockOptions/BlockViewOptions'
import BlockVideo from './BlockVideo'

const Block = memo(
  styled(
    ({
      layout,
      block,
      colWidth,
      editMode,
      cursor,
      active,
      location,
      contextMenu,
      closeContextMenu,
      ...props
    }) => {
      return (
        <div {...props}>
          {block.image ? (
            <BlockImage block={block} layout={layout} location={location} />
          ) : block.text ? (
            <BlockText block={block} />
          ) : block.video ? (
            <BlockVideo block={block} layout={layout} />
          ) : block.embed ? (
            <BlockEmbed block={block} layout={layout} />
          ) : null}
          {contextMenu && (
            <BlockViewOptions
              block={block}
              position={contextMenu}
              closeContextMenu={closeContextMenu}
            />
          )}
        </div>
      )
    }
  )(({ layout, block, active, colWidth, editMode, cursor }) => {
    const style = {
      label: 'Block',
      position: 'absolute',
      zIndex: active && z.activeBlock,
      pointerEvents: block.embed && editMode && 'none',
      ...layout
    }
    if (cursor) style.cursor = cursor
    else if (!editMode && (block.image || block.embed)) style.cursor = 'zoom-in'

    // Hacky fix for Safari 10
    if (cursor === 'zoom-out') style.position = 'relative'

    if (block.image) {
    } else if (block.text) {
      style.lineHeight = block.text.size > 0.5 ? 1.2 : 1.45
      style.textAlign = block.text.align || 'left'
      style.color = block.text.color || ''
      style.fontSize = block.text.size * colWidth
    } else if (block.embed) {
    } else {
      style.background = (block.style && block.style.background) || '#ccc'
    }
    return style
  })
)

export default Block
